/** @jsx jsx */

export const ActionBoxStyling = (
  anType: string, heightOffset: number, lighterColour: string, filteredColour: string
) => {

  let styling = ``;

  if (anType == "fundraiser") {
    styling = `
      html {
        scroll-behavior: smooth;
      }

      iframe#can_embed_iframe {
        height: ${(350 + heightOffset).toString()}px !important;
      }

      html.can_embed-html,
      html.can_embed-html body {
        background: white;
      }

      #logo_wrap,
      #can_embed_form div.affirmative_note {
        display: none;
      }

      #can_embed_form #donate_form {
        display: none;
      }

      #can_embed_form h2 {
        font-size: 2em;
        letter-spacing: -0.8px;
      }

      #can_embed_form #can_sidebar {
        display: flex;
        flex-direction: column-reverse;
      }

      #can_embed_form #can_sidebar .action_status_running_total {
        line-height: 2em;
        font-size: 1.4em;
        font-weight: 600;
      }

      #can_embed_form .action_status_goal {
        line-height: 2em;
        font-size: 0.9em;
        font-family: "IBM Plex Mono", Menlo, monospace;
        color: #6a6a6a;
      }

      #can_embed_form #can_sidebar .action_sidebar {
        width: 100%;
      }

      #can_embed_form #can_sidebar .action_sidebar img {
        width: 100%;
      }

      #can_embed_form #can_sidebar .action_sidebar .action_description {
        font-size: 1.1em;
      }

      #can_embed_form #can_sidebar .action_sidebar #action_info {
        display: none;
      }

      #can_embed_form #can_sidebar .action_widget .action_status_status_bar {
        width: 100%;
        height: 10px;
        font-size: 0;
        background-color: ${lighterColour};
        border-radius: 100px;
      }

      #can_embed_form #can_sidebar .action_widget .action_status_status_bar span {
        display: inline-block;
        height: 100%;
        background-color: ${filteredColour};
        border-radius: 100px;
      }

      #can_embed_form #can_sidebar .action_widget .action_status_status_bar span span {
        height: 100%;
        width: 100%;
        display: inline-block;
      }

      #fundraiser-cover.hidden {
        display: none;
      }

      @media screen and (max-width: 480px) {
        iframe#can_embed_iframe {
          height: ${(640 + heightOffset).toString()}px !important;
        }
      }

      @media screen and (min-width: 481px) and (max-width: 600px) {
        iframe#can_embed_iframe {
          height: ` + (440 + heightOffset).toString() + `px !important;
        }
      }

      @media screen and (min-width: 601px) and (max-width: 645px) {
        iframe#can_embed_iframe {
          height: ` + (380 + heightOffset).toString() + `px !important;
        }
      }

      @media screen and (min-width: 830px) and (max-width: 940px) {
        iframe#can_embed_iframe {
          height: ` + (440 + heightOffset).toString() + `px !important;
        }
      }
    `
  } else if (anType == "petition") {
    styling = `
      html {
        scroll-behavior: smooth;
      }

      #can_embed_form h2 {
        font-size: 2em;
        letter-spacing: -0.8px;
      }

      div#can_embed_form {
        font-family: 'neue-haas-grotesk-display','Neue Haas','Helvetica Neue','Helvetica',system-ui,sans-serif;
      }

      #can_embed_form div#can_main_col div.action_description p {
        font-size: 1.1em;
      }

      #can_embed_form div#can_main_col div#action_info,
      #can_embed_form div.affirmative_note {
        display: none;
      }

      #can_embed_form #can_sidebar .action_status_running_total {
        line-height: 2em;
        font-size: 1.4em;
        font-weight: 600;
      }

      #can_embed_form .action_status_goal {
        line-height: 2em;
        font-size: 0.9em;
        font-family: "IBM Plex Mono", Menlo, monospace;
        color: #6a6a6a;
      }

      #can_embed_form #can_sidebar .action_widget .action_status_status_bar {
        width: 100%;
        height: 10px;
        font-size: 0;
        background-color: ${lighterColour};
        border-radius: 100px;
      }

      #can_embed_form #can_sidebar .action_widget .action_status_status_bar span {
        display: inline-block;
        height: 100%;
        background-color: ${filteredColour};
        border-radius: 100px;
      }

      #can_embed_form #can_sidebar .action_widget .action_status_status_bar span span {
        height: 100%;
        width: 100%;
        display: inline-block;
      }

      #can_embed_form #can_sidebar .action_sidebar > h4 {
        display: none;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul {
        padding-left: 0px;
        margin-top: 0px;
        margin-bottom: 0px;
        color: #280000;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li#action_welcome_message {
        margin-top: 10px;
        background-color: rgb(252 22 75 / 20%);
        padding: 1.2em;
        border-radius: 15px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li.core_field div.floatlabel-wrapper {
        display: flex;
        flex-direction: column;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li.core_field div.floatlabel-wrapper > label.floatlabel-label {
        font-weight: 600;
        line-height: 1.8em;
        font-size: 1.1em;
        margin-top: 1.5em;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li.core_field div.floatlabel-wrapper > label[for=form-first_name] {
        margin-top: 0.2em;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li:nth-last-of-type(4) div.floatlabel-wrapper > input {
        margin-bottom: 1em;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li.core_field div.floatlabel-wrapper > input {
        border: none;
        border-bottom: 2px solid #280000;
        font-size: 1em;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul li::marker {
        font-size: 0px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul span.international_link-wrap > a.international_link,
      #can_embed_form #can_sidebar .action_sidebar form ul input[name=commit] {
        margin-top: 15px;
        appearance: none;
        font-size: 14px;
        text-align: center;
        line-height: 2em;
        padding: 8px 16px;
        background-color: #ffffff;
        border: 2px solid #FC164B;
        color: #FC164B;
        border-radius: 100px;
        text-decoration: none;
        font-weight: 500;
        user-select: none;
        outline: none;
        cursor: pointer;
        letter-spacing: -0.3px;
        white-space: break-spaces;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul span.international_link-wrap > a.international_link:hover,
      #can_embed_form #can_sidebar .action_sidebar form ul input[name=commit]:hover {
        background-color: #FC164B;
        color: #ffffff;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul input[name=commit] {
        font-size: 1.2em;
        padding-top: 0em;
        padding-bottom: 0em;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul .country_drop_wrap {
        border: 1px solid black;
        margin: 0px;
        width: 100%;
        display: block;
        padding: 7.5px;
        border-radius: 4px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul .country_drop_wrap.hide {
        display: none;
      }
      
      #can_embed_form #can_sidebar .action_sidebar form ul .country_drop_wrap #form-country {
        width: 100% !important;
        height: 20px !important;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul .country_drop_wrap span.can_selectInner {
        white-space: nowrap;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing {
        margin-top: 1em;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing .control-group .control-label{
        margin-bottom: 10px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing .control-group span.controls.check_radio_field {
        display: block;
        margin-bottom: 6px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing .control-group span.controls.check_radio_field > :first-child {
        margin-right: 8px;
        margin-bottom: 4px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing .control-group span.controls.check_radio_field label.radio {
        white-space: nowrap;
        line-height: 35px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing .control-group span.controls.check_radio_field label.radio input[type=radio] {
        vertical-align: middle;
        cursor: pointer;
        appearance: none;
        font-size: 60px;
        background: white;
        border: 2px solid white;
        outline: 2px solid #FC164B;
        width: 20px;
        height: 20px;
        border-radius: 20%;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        margin: 2px;
        margin-left: 1.5px;
        margin-right: 5px;
      }

      #can_embed_form #can_sidebar .action_sidebar form ul #d_sharing .control-group span.controls.check_radio_field label.radio input[type=radio]:checked {
        background: #FC164B;
        border: 2px solid #FED0DB;
        outline: 2px solid #FC164B;
      }

      #fundraiser-cover.hidden,
      #logo_wrap {
        display: none;
      }

      #can_embed_form input::placeholder {
        color: transparent;
      }

      #can_embed_form input::-webkit-input-placeholder {
        color: transparent;
      }

      #can_embed_form input:-moz-placeholder {
        color: transparent;
      }

      #can_embed_form input::-moz-placeholder {
        color: transparent;
      }

      #can_embed_form input:-ms-input-placeholder {
        color: transparent;
      }
    `
  }

  return styling;
}

export const ActionSidebarStyling = (
  anType: string, lighterColour: string, filteredColour: string
) => {
  let styling = ``;

  if (anType == "event") {
    styling = `
      #action-cover.hidden,
      #logo_wrap,
      #action_info,
      #can_embed_form form div#form_col2 img.ajax-loading,
      #can_embed_form div.affirmative_note {
        display: none;
      }

      #can_embed_form {
        font-family: "IBM Plex Mono", Menlo, monospace;
      }

      #can_embed_form form {
        font-family: 'neue-haas-grotesk-display','Neue Haas','Helvetica Neue','Helvetica',system-ui,sans-serif;
      }

      #can_embed_form div.last_line > h2 {
        display: none;
      }

      #can_embed_form div.last_line h4.first_line {
        padding-top: 15px;
        border-bottom: 2px solid rgb(198, 0, 226);
        padding-bottom: 25px;
      }

      #can_embed_form div.last_line h4.first_line span.bullet {
        display: block;
        color: #F7F4F1;
      }

      #can_embed_form div.last_line h4.first_line:first-of-type span.bullet {
        margin-top: 0.75em;
      }

      #can_embed_form div.last_line h4.first_line span.graytext {
        display: none;
      }

      #can_embed_form div.last_line h4.first_line:first-of-type span.bullet::before {
        content: "Time";
        color: #111;
        font-weight: 400;
        opacity: 0.6;
      }

      #can_embed_form div.last_line h4.first_line:first-of-type::before {
        content: "Date";
        display: block;
        font-size: 1em;
        font-weight: 500;
        opacity: 0.6;
      }

      #can_embed_form div.last_line h4.first_line:nth-of-type(2)::before {
        content: "Location";
        display: block;
        font-size: 1em;
        font-weight: 500;
        opacity: 0.6;
      }

      #can_embed_form #can_embed_form_inner > h4 {
        display: none;
      }

      #can_embed_form form div#form_col1 *::marker,
      #can_embed_form form div#form_col2 *::marker {
        font-size: 0px;
      }

      #can_embed_form form div#form_col1 li.core_field {
        margin-top: 7.5px;
        margin-bottom: 7.5px;
        width: 100%;
      }

      #can_embed_form form div#form_col1 li.core_field > div.floatlabel-wrapper {
        display: inline-block;
        width: 100%;
      }

      #can_embed_form form div#form_col1 li.core_field > div.floatlabel-wrapper > label {
        display: none !important;
      }

      #can_embed_form form div#form_col1 li.core_field > div.floatlabel-wrapper > input {
        font-size: 1em;
        width: 100%;
        height: 30px;
        border: none;
        margin-top: 0.2em;
        margin-bottom: 0.2em;
        border-radius: 0.5em;
        padding: 0.5em;
        line-height: 1em;
        font-weight: 600;
      }

      #can_embed_form form div#form_col1 div#action_welcome_message {
        margin-top: 10px;
        background-color: rgb(252 22 75 / 20%);
        padding: 1.2em;
        border-radius: 15px;
      }

      #can_embed_form form div#form_col1 li.control-group {
        margin-bottom: 1em;
      }

      #can_embed_form form div#form_col1 li.control-group label.control-label {
        display: inline-block;
        margin-top: 5px;
        margin-bottom: 5px;
      }

      #can_embed_form form div#form_col1 li.control-group span.controls {
        display: inline-block;
      }

      #can_embed_form form div#form_col1 li.control-group span.controls.check_radio_field > :first-child {
        margin-right: 15px;
      }

      #can_embed_form form div#form_col1 li.control-group span.controls.check_radio_field label.radio input[type=radio] {
        vertical-align: middle;
        cursor: pointer;
        appearance: none;
        font-size: 60px;
        background: white;
        border: 2px solid white;
        outline: 2px solid ${filteredColour};
        width: 20px;
        height: 20px;
        border-radius: 20%;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        margin: 2px;
        margin-left: 1.5px;
        margin-right: 5px;
      }

      #can_embed_form form div#form_col1 li.control-group span.controls.check_radio_field label.radio input[type=radio]:checked {
        background: ${filteredColour};
        border: 2px solid #FED0DB;
        outline: 2px solid ${filteredColour};
      }

      #can_embed_form form div#form_col1 span.international_link-wrap > a.international_link {
        font-family: "IBM Plex Mono", Menlo, monospace;
        color: ${filteredColour};
        text-decoration: underline;
      }

      #can_embed_form form div#form_col2 input[name=commit] {
        margin-top: 15px;
        appearance: none;
        font-size: 14px;
        text-align: center;
        line-height: 2em;
        padding: 8px 16px;
        background-color: #ffffff;
        border: 2px solid ${filteredColour};
        color: ${filteredColour};
        border-radius: 100px;
        text-decoration: none;
        font-weight: 500;
        user-select: none;
        outline: none;
        cursor: pointer;
        letter-spacing: -0.3px;
        white-space: break-spaces;
        width: 100%;
      }

      #can_embed_form form div#form_col2 input[name=commit] {
        line-height: 1em;
      }

      #can_embed_form form div#form_col1 span.international_link-wrap > a.international_link:hover {
        font-weight: 600;
        cursor: pointer;
      }

      #can_embed_form form div#form_col2 input[name=commit]:hover {
        background-color: ${filteredColour};
        color: #ffffff;
      }

      #can_embed_form form div#form_col1 .country_drop_wrap {
        border: 1px solid black;
        margin: 0px;
        width: 100%;
        display: block;
        padding: 7.5px;
        border-radius: 4px;
      }

      #can_embed_form form div#form_col1 .country_drop_wrap.hide {
        display: none;
      }
      
      #can_embed_form form div#form_col1 .country_drop_wrap #form-country {
        width: 100% !important;
        height: 20px !important;
      }

      #can_embed_form form div#form_col1 .country_drop_wrap span.can_selectInner {
        white-space: nowrap;
      }

      #can_embed_form form div#form_col2 #d_sharing {
        margin-top: 0.5em;
      }

      #can_embed_form form div#form_col2 #d_sharing ul {
        padding-left: 0px;
        margin-top: 0px;
        margin-bottom: 0px;
      }

      #can_embed_form form div#form_col2 #d_sharing .control-group .control-label{
        margin-bottom: 10px;
      }

      #can_embed_form form div#form_col2 #d_sharing .control-group span.controls.check_radio_field {
        display: block;
        margin-bottom: 6px;
      }

      #can_embed_form form div#form_col2 #d_sharing .control-group span.controls.check_radio_field > :first-child {
        margin-right: 8px;
        margin-bottom: 4px;
      }

      #can_embed_form form div#form_col2 #d_sharing .control-group span.controls.check_radio_field label.radio {
        white-space: nowrap;
        line-height: 35px;
      }

      #can_embed_form form div#form_col2 #d_sharing .control-group span.controls.check_radio_field label.radio input[type=radio] {
        vertical-align: middle;
        cursor: pointer;
        appearance: none;
        font-size: 60px;
        background: white;
        border: 2px solid white;
        outline: 2px solid ${filteredColour};
        width: 20px;
        height: 20px;
        border-radius: 20%;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        margin: 2px;
        margin-left: 1.5px;
        margin-right: 5px;
      }

      #can_embed_form form div#form_col2 #d_sharing .control-group span.controls.check_radio_field label.radio input[type=radio]:checked {
        background: ${filteredColour};
        border: 2px solid #FED0DB;
        outline: 2px solid ${filteredColour};
      }
    `
  }

  return styling;
}
